import { SET_REDIRECT_PATH } from "../actions/siteRedirectActions";

let initialState = { redirectPath: null };

export const siteRedirectReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REDIRECT_PATH:
      return { ...state, redirectPath: action.payload };
    default:
      return { ...state };
  }
};
